import { render, staticRenderFns } from "./TheGallery.vue?vue&type=template&id=49910138&scoped=true&"
import script from "./TheGallery.vue?vue&type=script&lang=js&"
export * from "./TheGallery.vue?vue&type=script&lang=js&"
import style0 from "./TheGallery.vue?vue&type=style&index=0&id=49910138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49910138",
  null
  
)

export default component.exports